
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderShippingGrid1 extends Serenity.EntityGrid<OrderShippingRow, any> {
        protected getColumnsKey() { return 'Orders.OrderShipping'; }
        protected getDialogType() { return OrderShippingDialog; }
        protected getIdProperty() { return OrderShippingRow.idProperty; }
        protected getInsertPermission() { return OrderShippingRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderShippingRow.localTextPrefix; }
        protected getService() { return OrderShippingService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push({
                title: 'Mark as Returned',
                cssClass: 'send-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/OrderShipping/MarkAsReturned', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            buttons.push({
                title: 'Mark as Delivered',
                cssClass: 'send-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/OrderShipping/MarkAsDelivered', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            return buttons;
        }
       
        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.OrderId != null ;
        }
      

        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }
        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderShippingRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}